import { Box, Stack } from '@mui/material';
import AccountDetailsForTeleAgent from '../../components/TeleAgent/TeleAgentManual/AccountDetailsForTeleAgent';
import TeleAgentAction from '../../components/TeleAgent/TeleAgentManual/TeleAgentAction';
import AdditionDetails from '../../components/TeleAgent/TeleAgentManual/AdditionDetails';
import AddressDetails from '../../components/TeleAgent/TeleAgentManual/AddressDetails';
import ContactDetails from '../../components/TeleAgent/TeleAgentManual/ContactDetails';
import LoanDetails from '../../components/TeleAgent/TeleAgentManual/LoanDetails';
import PaymentHistoryDetails from '../../components/TeleAgent/TeleAgentManual/PaymentHistoryDetails';
import PendingDuesDetails from '../../components/TeleAgent/TeleAgentManual/AdditionDetails';
import VegaBreadCrumb from '../../components/common/VegaBreadCrumb';
import VegaPageContent from '../../components/common/VegaPageContent';
import VegaPageHeader from '../../components/common/VegaPageHeader';
import { ROUTES } from '../../router/routes';
import { useParams } from 'react-router-dom';
import { useAppDispatch, useAppSelector } from '../../store';
import { useEffect } from 'react';
import {
  fetchLoanAccountList,
  fetchTeleAgentAllocation,
} from '../../actions/TeleAgentAction';
import { getTeleAgent } from '../../features/teleAgentSlice';

const TeleAgentAccountDetails = () => {
  const { loanAccountId } = useParams();
  const { allocations, totalItems: teleAllocationTotalItems } =
    useAppSelector(getTeleAgent);
  const dispatch = useAppDispatch();

  useEffect(() => {
    if (loanAccountId) {
      dispatch(
        fetchLoanAccountList({
          loanId: loanAccountId,
          includeCustomerDetails: true,
          includeLmsVariables: true,
          includeLoanOutstandingDetails: true,
          includeLoanTransactions: true,
          includeLoanPdcDetails: true,
        })
      );
    }
  }, [dispatch]);

  useEffect(() => {
    dispatch(fetchTeleAgentAllocation({ loanId: loanAccountId }));
  }, []);

  return (
    <>
      <VegaPageHeader
        sx={{ borderBottom: 'none', bgcolor: 'transparent' }}
        renderLeftView={() => {
          return (
            <VegaBreadCrumb
              items={[
                { label: 'My Account', link: ROUTES.TELE_AGENT_MANUAL },
                { label: `Account Details` },
              ]}
            />
          );
        }}
      />
      <AccountDetailsForTeleAgent />
      <TeleAgentAction
        loanAccountId={loanAccountId}
        allocationData={getFirstItemIfExists(allocations)}
        teleAllocationTotalItems={teleAllocationTotalItems}
      />
      <VegaPageContent sx={{ pt: '1rem' }}>
        <Box
          sx={{
            p: '1rem',
            bgcolor: 'white',
            borderRadius: '0.75rem',
            border: '1px solid #E1E4EB',
            my: '1rem',
          }}
        >
          <Stack gap={2}>
            <LoanDetails />
            <PaymentHistoryDetails />
            <PendingDuesDetails />
            <AddressDetails />
            <ContactDetails />
            <AdditionDetails />
          </Stack>
        </Box>
      </VegaPageContent>
    </>
  );
};

export default TeleAgentAccountDetails;
function getFirstItemIfExists<T>(arr: T[]): T | undefined {
  return arr?.[0];
}
